import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a25f697e")
const _hoisted_1 = { class: "page--limited card" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "p-mb-0" }, "Deleted", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "p-mb-0" }, "To be approved", -1)
const _hoisted_8 = { class: "p-d-flex p-ai-center" }
const _hoisted_9 = { class: "p-p-3" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_SendMessageDialog = _resolveComponent("SendMessageDialog")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_ShiftDeleteDialog = _resolveComponent("ShiftDeleteDialog")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BackButton, { to: _ctx.backRoute }, null, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isNew)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t('shift.title_new')), 1))
          : (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t('shift.title_detail')), 1)),
        (_ctx.isDeleted)
          ? (_openBlock(), _createBlock(_component_Chip, {
              key: 2,
              label: "Deleted",
              class: "p-ml-3 custom-chip"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.shift.status == 3)
          ? (_openBlock(), _createBlock(_component_Chip, {
              key: 3,
              label: "To be approved",
              class: "p-ml-3 tobeapp-chip"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createBlock(_component_SplitButton, {
              key: 0,
              label: "Save",
              icon: "pi pi-save",
              model: _ctx.actions,
              onClick: _ctx.onSave,
              disabled: _ctx.isReadOnly
            }, null, 8, ["model", "onClick", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_SendMessageDialog, {
          shift: _ctx.shift,
          visible: _ctx.displayMessageDialog,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayMessageDialog = $event)),
          all: _ctx.sendToAll,
          text: _ctx.message,
          subject: _ctx.subject,
          showRecipientOptions: true,
          onSent: _ctx.resetMessage
        }, null, 8, ["shift", "visible", "all", "text", "subject", "onSent"])
      ])
    ]),
    _createVNode(_component_TabMenu, { model: _ctx.tabs }, null, 8, ["model"]),
    _createVNode(_component_ShiftDeleteDialog, {
      shift: _ctx.shift,
      visible: _ctx.displayDeleteDialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayDeleteDialog = $event)),
      onDeleted: _ctx.onDeleted
    }, null, 8, ["shift", "visible", "onDeleted"]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({Component}) => [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              shift: _ctx.shift,
              isLoading: _ctx.requestPending,
              onSave: _ctx.onSave
            }, null, 8, ["shift", "isLoading", "onSave"]))
          ], 1024))
        ])
      ]),
      _: 1
    })
  ]))
}